<template>
  <TheGlobalLoading />
</template>

<script>
import TheGlobalLoading from '../../Layout/components/TheGlobalLoading';
import { bootstrap, casEnabled } from '../../../auth/authService';

export default {
  name: 'AuthStartLogout',
  components: { TheGlobalLoading },
  async mounted() {
    if (casEnabled()) {
      await bootstrap.logout();
    } else {
      this.$router.push({ path: '/auth/logout' });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/screens/Auth/components/StartLogout.vue